import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertDisplayType } from "@commonEnums/AlertDisplayType";
import { AlertService } from '@commonServices/alert.service';
import { RequestService } from "@commonServices/request.service";
import { AlertPositionType } from '@enums/alertPositionType';
import { KeywordsAppKeywordsDto, Client as NaturalLanguageProcessingApi } from '@interfaces/HttpClient/NaturalLanguageProcessingApiModels';
import { firstValueFrom, Observable } from 'rxjs';
import { AdministrationService } from './administration.service';
import { TranslationService } from './translation.service';

@Injectable()
export class KeywordsAppService {

	constructor(
		private naturalLanguageProcessingApi: NaturalLanguageProcessingApi,
		private requestService: RequestService,
		private administrationService: AdministrationService,
		private alertService: AlertService<AlertPositionType>,
		private translationService: TranslationService
	) { }

	// Suche schlagwörter
	async getSearchKeywords(catalogId?: number): Promise<KeywordsAppKeywordsDto> {
		try {
			const id = catalogId ? catalogId : this.administrationService.getId();
			return await firstValueFrom(this.naturalLanguageProcessingApi
				.keywordsApp_GetKeywordListsByCatalogId(id));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	isKeywordsAnalyzeDone(catalogId?: number): Observable<boolean> {
		try {
			const id = catalogId ? catalogId : this.administrationService.getId();
			return this.naturalLanguageProcessingApi
				.keywordsApp_IsKeywordsAnalyzeDone(id);
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async saveSearchKeywords(keywords: string[], catalogId?: number) {
		const id = catalogId ? catalogId : this.administrationService.getId();
		try {
			const result = await firstValueFrom(this.naturalLanguageProcessingApi.keywordsApp_UpdateSelectedKeywords(
				id,
				keywords
			));
			this.alertService.sendMessage(AlertPositionType.Global, AlertDisplayType.Success, this.translationService.getByKey(
				"catalog.search.keywords.save"
			));
			return result;
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}
}
